export const USERS = "users";
export const PROJECTS = "projects";
export const LABELS = "labels";
export const TODOS = "todos";
export const COLORS = "colors";
export const INBOX_COLOR_IDENTIFIER = "isInboxColor";
export const INBOX_PROJECT_IDENTIFIER = "isInbox";
export const DEFAULT_USER_PROJECT_NAME = "Inbox";
